import { Box, Container, SimpleGrid, Title, Text, Group, Stack } from '@mantine/core';
import { useResponsive } from '@/hooks/use-responsive';
import HighlightedText from '../HighlightedText';
import Button from '../Button';
import { MarkdownContent } from '@/app/page';
import { JSXElementConstructor, Key, PromiseLikeOfReactNode, ReactElement, ReactNode, ReactPortal, useEffect } from 'react';

interface HomeFeatureSectionProps {
    sectionId: string;
    markdownContent?: MarkdownContent;
}

export function HomeFeatureSection({ sectionId, markdownContent }: HomeFeatureSectionProps) {
    // const { content, error } = useSectionContent(sectionId);
    const { responsive } = useResponsive();
    const content = markdownContent?.frontmatter;
    useEffect(() => {
        // console.log('Home Feature Section Markdown Content:', markdownContent);
    }, [markdownContent]);
  
    if (!content) {
      return null;
    }
  
    const {
        title = 'Data Insight at Your Fingertips',
        subtitle = 'Multi-Family Data',
        description = 'Detect patterns and fluctuations in your data with Spotting Trends, fostering data-driven strategies for Condo, Strata, and HOA\'s.',
        buttonText = 'See Pricing',
        buttonHref = '/pricing',
        style = {
          background: 'gray.0',
          container: {
            maxHeight: 727
          },
          grid: {
            spacing: 40,
            verticalSpacing: 20
          },
          featuresGrid: {
            spacing: {
              xs: 30,
              sm: 15
            },
            marginY: {
              xs: 15,
              lg: 0
            }
          }
        },
        layout = {
          padding: {
            xs: 40,
            lg: 64
          }
        }
      } = content;
    
      return (
        <Box 
          bg={style.background} 
          py={responsive({
            xs: layout.padding?.xs || 40,
            lg: layout.padding?.lg || 64
          })}
        >
          <Container size="xl" mah={style.container?.maxHeight}>
            <SimpleGrid
              cols={responsive({ xs: 1, lg: 2 })}
              spacing={style.grid?.spacing}
              verticalSpacing={style.grid?.verticalSpacing}
              style={{ alignItems: 'center' }}
            >
              <Box>
                <HighlightedText>{subtitle}</HighlightedText>
                <Title size={48} fw={700}>
                  {title}
                </Title>
              </Box>
    
              <Text fz={21} fw={300}>
                {description}
              </Text>
    
              <Box style={{ alignSelf: 'flex-end', order: responsive({ xs: 1, lg: 0 }) }}>
                <Group>
                  <Button component="a" href={buttonHref} aria-label={buttonText} variant="outline">
                    {buttonText}
                  </Button>
                </Group>
              </Box>
    
              {content.features && content.features.length > 0 && (
                <SimpleGrid
                  my={responsive({
                    xs: style.featuresGrid?.marginY?.xs,
                    lg: style.featuresGrid?.marginY?.lg
                  })}
                  cols={responsive({ xs: 1, sm: 2 })}
                  spacing={responsive({
                    xs: style.featuresGrid?.spacing?.xs,
                    sm: style.featuresGrid?.spacing?.sm
                  })}
                >
                  {content.features.map((feature: { title: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | PromiseLikeOfReactNode | null | undefined; description: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | PromiseLikeOfReactNode | null | undefined; }, index: Key | null | undefined) => (
                    <Stack key={index} gap={15}>
                      <Title size={21} fw={500}>
                        {feature.title}
                      </Title>
                      <Text>
                        {feature.description}
                      </Text>
                    </Stack>
                  ))}
                </SimpleGrid>
              )}
            </SimpleGrid>
          </Container>
        </Box>
      );
    }